<template>
  <qd-message
    :title="$t('general.info')"
    type="is-info">
      <span> {{ $t('catalogue.info.isInRegroupementProduit') }} </span>
      <router-link-blank
        :to="{
          name: 'c.bodac.catalogue-detailRegroupementProduit',
          params: {id: regroupementProduit.id}
        }"
        :message="`${regroupementProduit.code} - ${regroupementProduit.libelle}`"
        class="lien is-inline">
      </router-link-blank>.
      <span> {{ $t('catalogue.info.updateProductInRegroupement') }} </span>
  </qd-message>
</template>

<script>
import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  props: {
    regroupementProduit: {
      type: Object,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
  },
};
</script>
